import { Panel } from "./shared";

export const WatermarkPanel = ({ value, onChange }) => (
  <Panel>
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Watermark text — e.g. CONFIDENTIAL"
      data-testid="watermark-input"
      className="w-full border border-hairline rounded-lg bg-page px-4 py-2.5 font-mono text-xs text-ink placeholder:text-mist focus:outline-none focus:border-azure transition-colors duration-300"
    />
  </Panel>
);
